var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{attrs:{"logo":"/img/logo.svg","autoClose":false},scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.permisos['ver dashboard'] && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-chart-bar-32 text-primary',
          path: '/dashboard'
        }}}):_vm._e(),_c('operations-manual-link'),_c('daily-menu-section'),_c('on-demand-section'),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Pedidos Tienda',
          icon: 'ni ni-building text-success',
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Pedidos Tienda', path: '/pedidos-tienda' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Control de Stock', path: '/pedidos-tienda/control-stock' }}})],1):_vm._e(),_c('franchise-section'),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Insumos',
          icon: 'ni ni-basket text-primary'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Lista de Insumos Daily',
            path: '/insumos'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Lista de Insumos Foodcourt',
            path: '/insumos/foodcourt'
          }}})],1):_vm._e(),(_vm.permisos['ver consolidados'] && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Consolidados',
          icon: 'ni ni-chart-pie-35 text-primary',
          path: '/consolidados'
        }}}):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Precantidades',
          icon: 'ni ni-shop text-primary'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Lista de Precantidades Daily',
            path: '/precantidades'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Lista de Precantidades Foodcourt',
            path: '/precantidades/foodcourt'
          }}})],1):_vm._e(),(!_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Auditorías',
          icon: 'ni ni-check-bold text-primary'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Historial',
            path: '/auditorias'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Intervenciones',
            path: '/auditorias/intervenciones'
          }}})],1):_vm._e(),(_vm.permisos['ver facturas'] && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
          name: 'Facturas',
          icon: 'ni ni-single-copy-04 text-primary',
          path: '/facturas'
        }}}):_vm._e(),(!_vm.isAlmacenero && _vm.showKitchenCharges)?_c('sidebar-item',{attrs:{"link":{
          name: 'Cobros de insumos',
          icon: 'ni ni-money-coins text-primary',
          path: '/cobros-insumos'
        }}}):_vm._e()]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{on:{"open-portal-update":_vm.openPortalUpdate}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1),_c('support-fab',{on:{"click":_vm.onSupportClick,"ver-tickets":_vm.onVerTicketsClick}}),_c('support-ticket-modal',{attrs:{"show":_vm.showTicketModal},on:{"update:show":function($event){_vm.showTicketModal=$event}}}),_c('mis-tickets-modal',{attrs:{"show":_vm.showMisTicketsModal,"focus-ticket-id":_vm.focusTicketId,"initial-action":_vm.ticketAction},on:{"update:show":function($event){_vm.showMisTicketsModal=$event}}}),_c('portal-update-modal',{attrs:{"items":_vm.portalUpdateQueue},on:{"close":_vm.closePortalUpdates}}),(_vm.hasDarkKitchen)?_c('manual-acknowledgement-notice'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }